<!-- Responsibility: Implement sys section ai performance behavior for the ui/panels surface.
Scope: Owns ui/panels concerns only; cross-surface orchestration is excluded. -->
<sys-section-ai-performance>
  <div>
    <h5 class="section-title" style="margin-top:var(--space-lg);">AI PERFORMANCE</h5>
    <p class="perf-note">
      Tracks each AI job route/stream call: provider used, latency, success/fail ratio, token estimates, and rough cost projection for the selected time window.
    </p>
    <div class="perf-window-toggle">
      <button class="action-btn { props.view?.perfWindow === '1h' ? 'primary' : '' }" onclick={ () => props.actions?.setPerfWindow?.('1h') }>1H</button>
      <button class="action-btn { props.view?.perfWindow === '6h' ? 'primary' : '' }" onclick={ () => props.actions?.setPerfWindow?.('6h') }>6H</button>
      <button class="action-btn { props.view?.perfWindow === '24h' ? 'primary' : '' }" onclick={ () => props.actions?.setPerfWindow?.('24h') }>24H</button>
      <button class="action-btn { props.view?.perfWindow === 'all' ? 'primary' : '' }" onclick={ () => props.actions?.setPerfWindow?.('all') }>ALL</button>
    </div>
    <p class="perf-note">
      Tracked calls: { props.view?.perfCount } · in { props.view?.perfInputTokens } tok · out { props.view?.perfOutputTokens } tok · est ${ props.view?.formatUsd?.(props.view?.perfCostUsd) }
    </p>
    <details class="cost-rates">
      <summary>TUNE COST RATES (ROUGH)</summary>
      <div class="cost-rates-grid">
        <div each={ (rate, provider) in props.view?.costRateDraft } class="cost-rate-row">
          <span class="cost-rate-provider">{ provider }</span>
          <label>in/M
            <input type="number" step="0.0001" value={ rate.inputUsdPer1MToken ?? '' } oninput={ (e) => props.actions?.onCostRateInput?.(provider, 'inputUsdPer1MToken', e) }>
          </label>
          <label>out/M
            <input type="number" step="0.0001" value={ rate.outputUsdPer1MToken ?? '' } oninput={ (e) => props.actions?.onCostRateInput?.(provider, 'outputUsdPer1MToken', e) }>
          </label>
          <label>req
            <input type="number" step="0.0001" value={ rate.perRequestUsd ?? '' } oninput={ (e) => props.actions?.onCostRateInput?.(provider, 'perRequestUsd', e) }>
          </label>
        </div>
      </div>
      <div class="cost-rate-actions">
        <button class="action-btn" onclick={ () => props.actions?.saveCostRates?.() }>SAVE RATES</button>
        <button class="action-btn" onclick={ () => props.actions?.resetCostRates?.() }>RESET DEFAULTS</button>
      </div>
    </details>
    <div class="perf-trend" if={ props.view?.perfTrend.length }>
      <div each={ point in props.view.perfTrend } class="perf-trend-row">
        <span class="perf-trend-time">{ props.view?.formatTrendLabel?.(point.bucketStartTs) }</span>
        <span class="perf-trend-bar"><i style={ `width:${Math.max(6, Math.round((point.total / props.view.perfTrendMax) * 100))}%` }></i></span>
        <span class="perf-trend-metrics">{ point.total } calls · { point.avgMs }ms</span>
      </div>
    </div>
    <div class="perf-list" if={ props.view?.perfSummary.length }>
      <div each={ row in props.view.perfSummary.slice(0, 8) } class="perf-row">
        <span class="perf-job">{ row.jobType }/{ row.provider }</span>
        <span class="perf-metrics">avg { row.avgMs }ms · p95 { row.p95Ms }ms · ok { row.ok }/{ row.total } · est ${ props.view?.formatUsd?.(row.estCostUsd) }</span>
      </div>
    </div>
    <p if={ !props.view?.perfSummary.length } class="perf-note">No telemetry yet. Play a few actions first.</p>
    <button class="action-btn" style="margin-top:var(--space-xs);" onclick={ () => props.actions?.exportPerfData?.() }>EXPORT PERF JSON</button>
    <button class="action-btn" style="margin-top:var(--space-xs);" onclick={ () => props.actions?.copyPerfSnapshot?.() }>COPY PERF SNAPSHOT</button>
    <button class="action-btn" style="margin-top:var(--space-xs);" onclick={ () => props.actions?.clearPerfData?.() }>CLEAR PERF DATA</button>
    <p class="perf-note" if={ props.view?.perfMessage }>{ props.view.perfMessage }</p>
  </div>
</sys-section-ai-performance>
